import React from 'react';
import style from './JobCard.module.sass';

const JobCard = ({ job, isDragging, onOpenDetail }) => {
  const handleMenuClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (onOpenDetail) {
      onOpenDetail(job);
    }
  };

  return (
    <div className={`${style.jobCard} ${isDragging ? style.dragging : ''}`}>
      <div className={style.cardHeader}>
        <div className={`${style.schoolName} ${job.has_changes ? style.changed : ''}`}>
          {job.school_name}
        </div>
        <button
          className={style.menuButton}
          onClick={handleMenuClick}
          onMouseDown={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
          title="View details"
        >
          &#8942;
        </button>
      </div>
      <div className={style.trigs}>{job.trigs || 0} trigs · {job.job || '-'}</div>
    </div>
  );
};

export default JobCard;
